const view = {
    break: { pageBreakBefore: "always", pageBreakAfter: "always" },
    brasao: { maxWidth: "100px", marginBottom: "2vh" },
    fonte: { fontWeight: "700", marginBottom: "1vh" },
    caixa: { margin: "auto", width: "86vw", border: "1px solid" },
    borda: { borderBottom: "1px solid" },
    id: { width: "43vw", display: "inline-block", textAlign: "left", paddingLeft: "2vw", verticalAlign: "top" },
    processo: {
        width: "42vw", display: "inline-block", borderLeft: "1px solid",
        textAlign: "left", paddingLeft: "2vw"
    },
    final: {textAlign: "right", fontWeight: "700", paddingRight: "7vw", marginTop: "3vh"}
}

export default view